module.exports = __webpack_public_path__ + "img/dm.9c0bf4bb.png";